import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52a3e5c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "customers"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
  /*#__PURE__*/_createElementVNode("th", null, "ARS"),
  /*#__PURE__*/_createElementVNode("th", null, "Paciente"),
  /*#__PURE__*/_createElementVNode("th", null, "Cobertura"),
  /*#__PURE__*/_createElementVNode("th"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "noRegist"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.$store.state.user.totalesFacturas)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.state.user.facturas, (factura, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", {
                onClick: ($event: any) => (this.$router.push(`/facturas/${factura._id}`)),
                class: _normalizeClass($options.toColor(factura.status))
              }, _toDisplayString(factura.idfact), 11, _hoisted_3),
              _createElementVNode("td", {
                onClick: ($event: any) => (this.$router.push(`/facturas/${factura._id}`)),
                class: _normalizeClass($options.toColorDate($options.diffDate(factura.fecha)))
              }, _toDisplayString($options.formatDate(factura.createdAt)) + " (" + _toDisplayString($options.diffDate(factura.fecha)) + " días) ", 11, _hoisted_4),
              _createElementVNode("td", {
                onClick: ($event: any) => (this.$router.push(`/facturas/${factura._id}`))
              }, _toDisplayString($options.getARS(factura.id_ars)), 9, _hoisted_5),
              _createElementVNode("td", {
                onClick: ($event: any) => (this.$router.push(`/facturas/${factura._id}`))
              }, _toDisplayString(factura.nom), 9, _hoisted_6),
              _createElementVNode("td", {
                onClick: ($event: any) => (this.$router.push(`/facturas/${factura._id}`)),
                class: _normalizeClass(["der", $options.toColorNumber(factura.cobertura)])
              }, _toDisplayString($options.formatNumber(factura.cobertura, true)), 11, _hoisted_7),
              _createElementVNode("td", null, [
                _createElementVNode("i", {
                  onClick: _withModifiers(($event: any) => ($options.moveStatus(factura, index)), ["prevent"]),
                  style: {"cursor":"pointer"},
                  class: "fas fa-angle-right blueOption"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("td", null, [
                (this.$store.state.user.numProcess == 4)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      onClick: _withModifiers(($event: any) => ($options.moveStatus2(factura, index)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-angle-double-right blueOption"
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, "Total: " + _toDisplayString($options.formatNumber(this.$store.state.user.totalesFacturas)), 1),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("td", {
              class: _normalizeClass([$options.toColorNumber(this.$store.state.user.totalesCobertura), "der"])
            }, _toDisplayString($options.formatNumber(this.$store.state.user.totalesCobertura, true)), 3),
            _hoisted_13,
            _hoisted_14
          ])
        ]))
      : _createCommentVNode("", true),
    (!this.$store.state.user.totalesFacturas)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_15, " No se Encontraron Registros. "))
      : _createCommentVNode("", true)
  ], 64))
}